module.exports = __webpack_public_path__ + "img/exam_3.42c5be39.png";